import React from 'react';
import PropTypes from 'prop-types';
import HeaderBackground from '../../../molecules/shared/headerBackground/HeaderBackground';
import { Typography } from '../../../atoms/typography/Typography';
import SearchInput from '../../../molecules/shared/navigationBar/searchInput/SearchInput';

const Header = ({
  title,
  headerTextStyled = false,
  headerText = '',
  headerDescription = '',
  headerContent,
  card,
  minHeight,
  minimized,
  isLargeWidth,
  isHeaderCentered,
  curved,
  t,
  search,
  show = true,
  fade = false,
}) => {
  if (!show) {
    return null;
  }

  return (
    <HeaderBackground
      minimized={minimized}
      minHeight={minHeight}
      curved={curved}
      fade={fade}
    >
      <div className="flex flex-1 flex-col justify-center mt-12">
        {title && (
          <Typography textAlign="left" fontVariant="h7" className="!text-white">
            {title}
          </Typography>
        )}
        {headerTextStyled && headerText && (
          <Typography
            as="h1"
            textAlign={isHeaderCentered ? 'center' : 'left'}
            fontVariant="h3"
            className={`my-3 leading-tight !text-white ${
              isHeaderCentered ? 'self-center' : ''
            } ${isLargeWidth ? 'max-w-3xl' : 'max-w-md'}`}
            dangerouslySetInnerHTML={{ __html: headerText }}
          ></Typography>
        )}
        {!headerTextStyled && headerText && (
          <Typography
            as="h1"
            textAlign={isHeaderCentered ? 'center' : 'left'}
            fontVariant="h3"
            className={`my-3 leading-tight !text-white max-sm:text-clamp-h5 ${
              isHeaderCentered ? 'self-center' : ''
            } ${isLargeWidth ? 'max-w-3xl' : 'max-w-md'}`}
          >
            {headerText}
          </Typography>
        )}
        {headerContent ||
          (headerDescription && (
            <Typography
              as="h2"
              textAlign={isHeaderCentered ? 'center' : 'left'}
              fontVariant="p1"
              className={`mt-4 font-normal leading-normal !text-white ${
                isHeaderCentered && 'self-center'
              }`}
            >
              {headerDescription}
            </Typography>
          ))}
        {search && (
          <div className="mt-10">
            <SearchInput
              handleInputChange={search.onSearchChange}
              onBlur={() => {}}
              results={search.searchSuggestions}
              open={search.searchVisible}
              query={search.searchValue}
              t={t}
              large
              handleSearchClick={search.onSearchClick}
            />
          </div>
        )}
      </div>
      {card && (
        <div className="flex flex-1 justify-center items-center">{card}</div>
      )}
    </HeaderBackground>
  );
};

export default Header;

Header.propTypes = {
  headerText: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  headerDescription: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
};
